import { render, staticRenderFns } from "./KeyReturnCommon.vue?vue&type=template&id=2bf3c5b8&scoped=true&"
import script from "./KeyReturnCommon.vue?vue&type=script&lang=js&"
export * from "./KeyReturnCommon.vue?vue&type=script&lang=js&"
import style0 from "./KeyReturnCommon.vue?vue&type=style&index=0&id=2bf3c5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf3c5b8",
  null
  
)

export default component.exports